import SEO from "../components/SEO";
import React, { useEffect } from "react";

import { makeStyles } from "@material-ui/core/styles";
import tick from "../images/v2/psg/tick.svg";
import mainHeaderImg from "../images/v2/psg/mainHeaderImg.webp";
import { motion } from "framer-motion";
import psgIcon1 from "../images/v2/psg/psgIcon1.svg";
import psgIcon2 from "../images/v2/psg/psgIcon2.svg";
import psgIconClipboard from "../images/v2/psg/psgIconClipboard.svg";
import psgIconUpload from "../images/v2/psg/psgIconUpload.svg";
import useWidth from "../hooks/useWidth";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import HeaderTypography from "../components/v2/Typography/HeaderTypography";
import ParagraphTypography from "../components/v2/Typography/ParagraphTypography";
import Paper from "@material-ui/core/Paper";
import loadable from "@loadable/component";
import Divider from "@material-ui/core/Divider";
import FaqSection from "../components/v4/FaqSection/FaqSection";
import psgCard1 from "../images/v2/psg/psgCard1.webp";
import psgCard2 from "../images/v2/psg/psgCard2.webp";
import psgCard3 from "../images/v2/psg/psgCard3.webp";
import psgCard4 from "../images/v2/psg/psgCard4.webp";
import psgCard5 from "../images/v2/psg/psgCard5.webp";
import psgCard6 from "../images/v2/psg/psgCard6.webp";
import psgCard7 from "../images/v2/psg/psgCard7.webp";
import clsx from "clsx";
import "../styles/index.scss";
import IMDALockup from "../components/v4/IMDALockup/IMDALockup";
const LazyLoad = loadable(() => import("react-lazyload"));

const glowBorder = "solid 1px #2b91ae";
const glowShadow = "0 0px 25px 0 rgb(76 143 162)";

const useStyles = makeStyles((theme) => ({
   smeFooterText: {
      textAlign: "left",
      fontFamily: "Inter !important",
      fontWeight: 400,
      color: "#0A2035",
      [theme.breakpoints.down("sm")]: {
         fontSize: "14px",
      },
   },
   smeFooterText2: {
      textAlign: "center",
      [theme.breakpoints.down("sm")]: {
         fontSize: "14px",
         textAlign: "center",
      },
   },
   securityBannerBg: {
      background:
         "radial-gradient(60% 40% at top left, rgb(235, 212, 252) 0%, transparent 100%), radial-gradient(60% 40% at top right, rgba(255, 163, 101, 0.5) 0%, transparent 100%), #fff",
      backgroundRepeat: "no-repeat",
   },
   requestDemoRoot: {
      background:
         "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
      backgroundSize: "cover",
   },
   "@keyframes glow": {
      "0%": {
         border: "solid 1px #e2f0ff",
         boxShadow: "0 15px 50px 0 rgba(118, 130, 183, 0.16)",
      },
      "20%": {
         border: glowBorder,
         boxShadow: glowShadow,
      },
      "40%": {
         border: "solid 1px #e2f0ff",
         boxShadow: "0 15px 50px 0 rgba(118, 130, 183, 0.16)",
      },
      "80%": {
         border: glowBorder,
         boxShadow: glowShadow,
      },
      "100%": {
         border: "solid 1px #e2f0ff",
         boxShadow: "0 15px 50px 0 rgba(118, 130, 183, 0.16)",
      },
   },
   contactUsCard: {
      boxShadow: "0 15px 50px 0 rgba(118, 130, 183, 0.16)",
      padding: "8px 24px",
      borderRadius: "0 0 10px 10px",
      border: "solid 1px #e2f0ff",
      maxWidth: 450,
      width: "100%",
      [theme.breakpoints.down("sm")]: {
         padding: theme.spacing(0.5),
      },
      // animation: "3s $glow",
      // transition: "all .5s",
      "&.glow": {
         animation: "3s $glow",
      },
   },
   psgBoxContainer: {
      [theme.breakpoints.down("sm")]: {
         flexDirection: "column",
      },
   },
   // Application steps: numbered dots joined by a dashed line, each above its
   // card. Below "sm" the same markup turns vertical: dots down the left,
   // each card centred on its dot.
   psgSteps: {
      display: "flex",
      gap: "24px",
      margin: "0 auto",
      [theme.breakpoints.down("sm")]: {
         flexDirection: "column",
         gap: "16px",
         maxWidth: "560px",
      },
   },
   psgStep: {
      flex: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      // The dashed line is drawn per step (half before the dot, half after);
      // psgStepDotWrap reaches half a gap into the space on each side, so the
      // halves meet in the gaps and the line stops at the first/last dot.
      "&:first-child $psgStepDotWrap::before, &:last-child $psgStepDotWrap::after":
         {
            display: "none",
         },
      [theme.breakpoints.down("sm")]: {
         flexDirection: "row",
         alignItems: "stretch",
         gap: "16px",
      },
   },
   psgStepDotWrap: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: "0 -12px 32px", // -12px = half of psgSteps' 24px gap
      "&::before, &::after": {
         content: '""',
         position: "absolute",
         top: "50%",
         width: "50%",
         borderTop: "1.5px dashed #FF7A59",
      },
      "&::before": {
         left: 0,
      },
      "&::after": {
         right: 0,
      },
      [theme.breakpoints.down("sm")]: {
         margin: "-8px 0", // half of psgSteps' 16px gap
         width: "44px",
         flexShrink: 0,
         "&::before, &::after": {
            top: "auto",
            left: "50%",
            right: "auto",
            width: 0,
            height: "50%",
            borderTop: "none",
            borderLeft: "1.5px dashed #FF7A59",
            transform: "translateX(-50%)",
         },
         "&::before": {
            top: 0,
         },
         "&::after": {
            bottom: 0,
         },
      },
   },
   psgStepDot: {
      position: "relative",
      zIndex: 1,
      width: "42px",
      height: "42px",
      borderRadius: "50%",
      border: "1.5px solid #FF7A59",
      background: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 500,
      fontSize: "14px",
      color: "#0A2035",
      flexShrink: 0,
      [theme.breakpoints.down("sm")]: {
         width: "36px",
         height: "36px",
         fontSize: "12px",
      },
   },
   psgStepCardWrap: {
      flex: 1,
      display: "flex",
      [theme.breakpoints.down("sm")]: {
         alignItems: "center",
      },
   },
   psgIconContainer: {
      width: "52px",
      height: "52px",
      minWidth: "52px",
      borderRadius: "10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      [theme.breakpoints.down("sm")]: {
         width: "44px",
         height: "44px",
         minWidth: "44px",
      },
   },
   psgIconPurple: {
      backgroundColor: "#9E5AD5",
   },
   psgIconTeal: {
      backgroundColor: "#3E9A92",
   },
   psgIconBlue: {
      backgroundColor: "#2E73E6",
   },
   psgIconOrange: {
      backgroundColor: "#EE7B5B",
   },
   psgCardText: {
      fontSize: "15px",
      lineHeight: 1.6,
      fontFamily: "'Wix Madefor Display', sans-serif",
      color: "#0A2035",
      margin: 0,
   },
   psgBox: {
      boxShadow: "0 4px 24px 0 rgb(118 130 183 / 12%)",
      borderRadius: 14,
      width: "100%",
      display: "flex",
      alignItems: "center",
      gap: "16px",
      padding: "12px",
      background: "#fff",
      textDecoration: "none",
      "&:hover, &:visited, &:link, &:active": {
         textDecoration: "none",
      },
      [theme.breakpoints.down("xs")]: {
         padding: "16px",
         gap: "14px",
      },
   },
   psgBoxLink: {
      cursor: "pointer",
      transition: "box-shadow 0.2s ease",
      "&:hover": {
         boxShadow: "0 8px 30px 0 rgb(118 130 183 / 24%)",
      },
   },
   list: {
      "& li": {
         listStyle: "none",
         marginBottom: 10,
         fontSize: "20px",
      },
      "@media (max-width: 600px)": {
         paddingLeft: "18px",
      },
   },
   expendButton: {
      backgroundColor: "#eaf0f6",
      "&:hover": {
         background: "#a1dae2",
      },
   },
   link: {
      color: "#4592ae",
      fontSize: 18,
      fontWeight: 500,
      lineHeight: 1.6,
      fontFamily: "Inter, sans-serif !important",
      textDecoration: "none",
      "&:hover, &:visited, &:link, &:active": {
         textDecoration: "none",
      },
   },
   faqTitle: {
      color: "#010f1d",
      display: "flex",
      fontSize: 20,
      marginTop: 10,
      fontWeight: 600,
      marginBottom: 8,
      justifyContent: "space-between",
      alignItems: "center",
   },
   faqAnswer: {
      color: "#0a2035",
      fontFamily: "Inter, sans-serif !important",
      lineHeight: "1.6",
      fontWeight: 400,
      marginBottom: 20,
      marginTop: 8,
      maxWidth: 920,
      width: "calc( 100% - 50px )",
   },
   PCBenefitsText: {
      width: "552px",
      lineHeight: "1.2",
      fontWeight: "600",
      textAlign: "left",
      color: "#fff",
      paddingTop: "381px",
      paddingLeft: "141px",
      [theme.breakpoints.down("xs")]: {
         paddingTop: "147px",
         paddingLeft: "12px",
         width: "100%",
      },
      [theme.breakpoints.down("sm")]: {
         width: "302px",
         paddingTop: "279px",
         paddingLeft: "23px",
      },
   },
   PCBenefitsList: {
      [theme.breakpoints.up("sm")]: {
         marginTop: "-20px",
      },
      [theme.breakpoints.up("md")]: {},
      [theme.breakpoints.down("xs")]: {
         marginTop: "0px",
         paddingTop: "0px",
      },
   },
   smeBannerTxthead: {
      padding: "3px",
      margin: "0",
      marginLeft: "5px",
   },
   martop: {
      marginTop: "10px",
   },
   listItemTextTitle: {
      color: "#010f1d",
      lineHeight: "1.2",
      fontWeight: "600",
      marginTop: "0px",
      marginBottom: "8px",

      [theme.breakpoints.up("sm")]: {
         marginBottom: "12px",
      },
      [theme.breakpoints.up("md")]: {
         marginBottom: "12px",
      },
   },
   listItemTextDescription: {
      paddingBottom: "20px",
      margin: "0px",
      fontWeight: "normal",
      fontFamily: "Inter, sans-serif !important",
      lineHeight: "1.6",
      width: "735px",
      color: "#0A2035",
      [theme.breakpoints.up("xs")]: {
         paddingBottom: "30px",
         width: "90%",
      },
      [theme.breakpoints.up("sm")]: {
         paddingBottom: "0px",
         width: "105%",
      },
      [theme.breakpoints.up("md")]: {
         paddingBottom: "20px",
      },
   },
   listStyle: {
      color: " #0698b4",
      marginBottom: "0",
      "& li": {
         fontSize: "24px",
         "&:last-child": {
            "& div": {
               paddingBottom: "0",
            },
         },
      },
   },
   listContainer: {
      display: "flex",
      [theme.breakpoints.down("xs")]: {
         display: "block",
      },
   },
   requestDemoRootWidth: {
      width: "100%",
      [theme.breakpoints.down("xs")]: {
         width: "100%",
         padding: "0px",
      },
      [theme.breakpoints.down("sm")]: {
         width: "100%",
         padding: "0px",
      },
   },
   ButtonRound32: {
      borderRadius: "32px",
      padding: "8px 40px !important",
      fontSize: "18px !important",
   },
   headerTextColor: {
      color: "#010f1d",
   },
   heroSection: {
      marginTop: "60px",
      "@media(max-width:768px)": {
         marginTop: "0",
      },
   },
   formCard: {
      borderRadius: "16px",
      boxShadow: "0 4px 24px rgba(0,0,0,0.10)",
      width: "450px",
      overflow: "hidden",
      backgroundColor: "#fff",
      [theme.breakpoints.down("xs")]: {
         width: "100%",
      },
   },
   formCardHeader: {
      background:
         "linear-gradient(90deg,rgba(12, 64, 141, 1) 0%, rgba(2, 129, 97, 1) 100%)",
      borderRadius: "16px 16px 0 0",
      padding: "14px 24px",
      textAlign: "center",
      "& span": {
         color: "#5CFFB2 !important",
         fontSize: "26px",
         margin: "0 6px",
      },
   },
   formCardBody: {
      padding: "10px",
      [theme.breakpoints.down("xs")]: {
         padding: "5px",
      },
   },
   centerButton: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "0!important",
   },
   imdaWrapper: {
      background:
         "linear-gradient(0deg,rgba(255, 255, 255, 1) 54%, rgb(250, 247, 255) 80%, rgba(241, 223, 255, 1) 100%)",
   },
   commonSpacing: {
      paddingTop: "65px",
      paddingBottom: "65px",
      "@media(max-width: 1024px)": {
         padding: "65px 15px",
      },
      "@media(max-width: 600px)": {
         padding: "40px 15px",
      },
   },
   bannerHeading: {
      fontSize: "64px",
      "@media(max-width:1024px)": {
         fontSize: "48px",
      },
      "@media(max-width:600px)": {
         fontSize: "34px",
      },
   },
   mainHeading: {
      fontSize: "56px",
      fontWeight: 600,
      marginBottom: "48px",
      "@media(max-width:1200px)": {
         fontSize: "48px",
      },
      "@media(max-width:992px)": {
         fontSize: "40px",
      },
      "@media(max-width:600px)": {
         fontSize: "32px",
         marginBottom: "32px",
      },
   },
   subHeading: {
      fontSize: "24px",
      "@media(max-width:1024px)": {
         fontSize: "20px",
      },
   },
   bannerText: {
      fontSize: "20px",
      "@media(max-width:1024px)": {
         fontSize: "16px",
      },
   },
   commonText: {
      fontSize: "18px",
      "@media(max-width:1024px)": {
         fontSize: "14px",
      },
   },
   smallText: {
      fontSize: "16px",
      "@media(max-width:1024px)": {
         fontSize: "14px",
      },
   },
   packageSection: {
      background:
         "radial-gradient(circle at 50% 0%, rgba(0, 154, 153, 0.5) 0%, transparent 50%), #021D1D",
      padding: "72px 0",
      "@media(max-width:768px)": {
         padding: "48px 0",
      },
   },
   psgApplicationProcess: {
      background:
         "linear-gradient(0deg,rgba(255, 255, 255, 1) 54%, rgb(250, 247, 255) 74%, rgba(241, 223, 255, 1) 100%)",
   },
   packageSectionTitle: {
      color: "#fff",
      fontSize: "56px",
      fontWeight: 600,
      textAlign: "center",
      lineHeight: 1.2,
      margin: "0 auto 48px auto",
      "@media(max-width:1200px)": {
         fontSize: "48px",
      },
      "@media(max-width:992px)": {
         fontSize: "40px",
      },
      "@media(max-width:600px)": {
         fontSize: "32px",
         marginBottom: "32px",
      },
   },
   packagesRow: {
      display: "flex",
      flexDirection: "row",
      gap: "16px",
      maxWidth: "800px",
      margin: "0 auto",
      marginBottom: "28px",
      [theme.breakpoints.down("sm")]: {
         flexDirection: "column",
         justifyContent: "center",
         alignItems: "center",
      },
   },
   packageTypeCardMonthly: {
      background: "rgba(255, 255, 255, 0.1)",
      borderRadius: "16px",
      padding: "24px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "10px",
      width: "100%",
      position: "relative",
      overflow: "hidden",
      "&.glass-effect": {
         "&::before": {
            content: '""',
            position: "absolute",
            width: "300px",
            height: "300px",
            zIndex: "0",
            background: "var(--before-gradient)",
            borderRadius: "50%",
            filter: "blur(80px)",
            opacity: "var(--before-opacity, 0)",
            left: "var(--before-left, 0)",
            top: "var(--before-top, 0)",
            transition: "opacity 0.3s ease",
            pointerEvents: "none",
         },
      },
      "& > *": {
         position: "relative",
         zIndex: "1",
      },
   },
   packageTypeCardEnterprise: {
      background: "rgba(255, 255, 255, 0.1)",
      borderRadius: "16px",
      padding: "24px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "10px",
      width: "100%",
      position: "relative",
      overflow: "hidden",
      "&.glass-effect": {
         "&::before": {
            content: '""',
            position: "absolute",
            width: "300px",
            height: "300px",
            zIndex: "0",
            background: "var(--before-gradient)",
            borderRadius: "50%",
            filter: "blur(80px)",
            opacity: "var(--before-opacity, 0)",
            left: "var(--before-left, 0)",
            top: "var(--before-top, 0)",
            transition: "opacity 0.3s ease",
            pointerEvents: "none",
         },
      },
      "& > *": {
         position: "relative",
         zIndex: "1",
      },
   },
   packageTypeTitle: {
      color: "#fff",
      textAlign: "center",
      fontSize: "24px",
      fontWeight: 600,
      marginBottom: "16px",
   },
   packageItemsRow: {
      display: "flex",
      flexDirection: "row",
      gap: "12px",
   },
   packageItem: {
      flex: 1,
      background: "rgba(255,255,255,0.12)",
      border: "1px solid rgba(255,255,255,0.18)",
      borderRadius: "12px",
      padding: "20px 14px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
   },
   packageItemEnterprise: {
      background: "rgba(255,255,255,0.1)",
      borderRadius: "12px",
      display: "inline-flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "90px",
      height: "90px",
   },
   packageUserCount: {
      color: "#fff",
      fontSize: "24px",
      fontWeight: 700,
      lineHeight: 1,
      marginBottom: "2px",
   },
   packageUserLabel: {
      color: "rgba(255, 255, 255, 1)",
      fontSize: "12px",
      fontWeight: 400,
      letterSpacing: "0.5px",
   },
   packageBtn: {
      background: "rgba(255,255,255,0)",
      border: "1.5px solid rgba(255,255,255,1)",
      borderRadius: "20px",
      color: "#fff",
      fontSize: "16px",
      fontWeight: 500,
      padding: "10px 16px",
      cursor: "pointer",
      whiteSpace: "nowrap",
      marginTop: "20px",
      transition: "background 0.3s ease, border-color 0.3s ease",
      "&:hover": {
         background:
            "linear-gradient(90deg, #FF682A 0%, #FF8958 36%, #FFB54B 66%, #FF6F65 100%)",
         borderColor: "transparent",
         backgroundSize: "600%",
      },
   },
   packageFootnote: {
      color: "rgba(255,255,255,1)",
      fontSize: "16px",
      textAlign: "center",
      "& a": {
         color: "rgba(255,255,255,1)",
      },
   },
   benefitsSection: {
      background:
         "radial-gradient(ellipse at 95% 14%, rgba(158, 90, 213, 0.4) 0%, transparent 25%), radial-gradient(ellipse at 4% 25%, rgba(158, 90, 213, 0.3) 0%, transparent 18%), radial-gradient(ellipse at 10% 95%, rgba(32, 142, 236, 0.4) 0%, transparent 50%), radial-gradient(ellipse at 110% 75%, rgba(32, 142, 236, 0.3) 0%, transparent 20%), #021D1D",
      padding: "72px 0",
      "@media(max-width:768px)": {
         padding: "48px 0",
      },
   },
   benefitsSectionTitle: {
      color: "#fff",
      fontSize: "56px",
      fontWeight: 600,
      textAlign: "center",
      marginBottom: "48px",
      lineHeight: 1.2,
      "@media(max-width:1200px)": {
         fontSize: "48px",
      },
      "@media(max-width:992px)": {
         fontSize: "40px",
      },
      "@media(max-width:600px)": {
         fontSize: "32px",
         marginBottom: "32px",
      },
   },
   benefitCard: {
      background: "rgba(0,0,0,0.20)",
      border: "1px solid rgba(255, 255, 255, 0.2)",
      borderRadius: "16px",
      padding: 0,
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      height: "100%",
      width: "100%",
      position: "relative",
      "&.glass-effect": {
         "&::before": {
            content: '""',
            position: "absolute",
            width: "300px",
            height: "300px",
            zIndex: "0",
            background: "var(--before-gradient)",
            borderRadius: "50%",
            filter: "blur(80px)",
            opacity: "var(--before-opacity, 0)",
            left: "var(--before-left, 0)",
            top: "var(--before-top, 0)",
            transition: "opacity 0.3s ease",
            pointerEvents: "none",
         },
      },
      "& > *": {
         position: "relative",
         zIndex: "1",
      },
   },
   benefitCardRow: {
      flexDirection: "row",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
         flexDirection: "column",
         justifyContent: "center",
         alignItems: "center",
      },
   },
   benefitCardRowText: {
      flex: 1,
      minWidth: 0,
      padding: "28px",
   },
   benefitCardRowImg: {
      flex: 1,
      width: "50%",
      maxWidth: "50%",
      borderRadius: "8px",
      display: "block",
      transform: "translateY(28px)",
      [theme.breakpoints.down("sm")]: {
         width: "100%",
         maxWidth: "100%",
         transform: "translateY(16px)",
      },
   },
   benefitCardTitle: {
      color: "#fff",
      fontSize: "24px",
      fontWeight: 700,
      margin: "28px 28px 10px 28px",
      [theme.breakpoints.down("xs")]: {
         margin: "16px 16px 10px 16px",
      },
      lineHeight: 1.3,
   },
   benefitCardTitleRow: {
      margin: "0 0 10px 0",
   },
   benefitCardDesc: {
      color: "#fff",
      fontSize: "16px",
      lineHeight: 1.6,
      fontFamily: "Inter, sans-serif",
      fontWeight: 400,
      margin: "0 28px 28px 28px",
      [theme.breakpoints.down("xs")]: {
         margin: "0 16px 16px 16px",
      },
   },
   benefitCardDescRow: {
      margin: 0,
   },
   benefitCardImg: {
      width: "100%",
      display: "block",
      marginTop: "auto",
      borderRadius: "0",
   },
   benefitsRow: {
      marginBottom: "8px",
   },
   benefitsGridItem: {
      display: "flex",
   },
   benefitsCol28: {
      display: "flex",
      flexBasis: "28%",
      maxWidth: "28%",
      [theme.breakpoints.down("sm")]: {
         flexBasis: "100%",
         maxWidth: "100%",
      },
   },
   benefitsColRemaining: {
      display: "flex",
      flexBasis: "44%",
      maxWidth: "44%",
      [theme.breakpoints.down("sm")]: {
         flexBasis: "100%",
         maxWidth: "100%",
      },
   },
}));

const faqs = [
   {
      question: "What is the EDGE Grant?",
      answer: (
         <>
            The{" "}
            <a href="https://blog.peppercloud.com/edge-grant-singapore-a-comprehensive-guide-for-businesses/">
               EDGE Grant in Singapore
            </a>{" "}
            is Enterprise Singapore's new business grant that consolidates the
            Enterprise Development Grant (EDG), Productivity Solutions Grant
            (PSG) and Market Readiness Assistance (MRA) into one grant framework
            from 30 September 2026.
         </>
      ),
      schemaAnswer:
         "The EDGE Grant in Singapore is Enterprise Singapore's new business grant that consolidates the Enterprise Development Grant (EDG), Productivity Solutions Grant (PSG) and Market Readiness Assistance (MRA) into one grant framework from 30 September 2026.",
   },
   {
      question: "When does the EDGE Grant replace PSG?",
      answer:
         "PSG, EDG and MRA will cease accepting new applications on 29 September 2026. From 30 September 2026, businesses should apply for support under EDGE. Existing PSG, EDG and MRA submissions or projects will continue to be processed under the respective schemes.",
   },
   {
      question: "How much EDGE Grant support can a business receive?",
      answer:
         "EDGE provides 50% support, depending on the eligible activity. Businesses can receive up to S$100,000 in total grant support per year across activities.",
   },
   {
      question: "Can I apply for EDGE Grant support for Pepper Cloud CRM?",
      answer:
         "CRM adoption may be relevant where it forms part of an eligible Automation & Digitalisation activity. However, eligibility and the applicable support level depend on the specific activity and EnterpriseSG's requirements. Businesses should confirm the supportability of their proposed project before applying.",
   },
   {
      question: "What is the EDGE Grant annual funding cap?",
      answer:
         "Businesses can access up to S$100,000 in total grant support per year across all eligible EDGE activities. The cap is shared across activities and refreshed on 1 April each year.",
   },
   {
      question: "Is EDGE Grant support paid upfront?",
      answer:
         "No. EDGE Grant support is provided on a reimbursement basis. Claims can be submitted after the supported activity has been completed and full payment has been made.",
   },
   {
      question: "Can I start my CRM project before receiving EDGE approval?",
      answer:
         "Businesses should obtain the required grant approval before commencing the project. Starting work, making payments or entering into arrangements that constitute project commencement before approval may affect eligibility. Check the applicable EDGE requirements before committing to the project.",
   },
   {
      question: "What happened to the PSG grant?",
      answer:
         "PSG will cease for new applications on 29 September 2026. From 30 September 2026, new business grant applications will be made under EDGE instead. Existing PSG projects continue to be processed and can proceed to claims upon completion.",
   },
];

const faqSchema = {
   "@context": "https://schema.org",
   "@type": "FAQPage",
   mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
         "@type": "Answer",
         text: faq.schemaAnswer || faq.answer,
      },
   })),
};

const PSG = () => {
   const width = useWidth();
   const classes = useStyles();

   const glowForm = () => {
      const form = document.getElementById("psg-form");
      const formContainer = document.getElementById("psg-form-container");
      formContainer.scrollIntoView({ behavior: "smooth", block: "start" });
      form.classList.remove("glow");
      form.classList.add("glow");
      setTimeout(() => {
         form.classList.remove("glow");
      }, 3200);
   };

   const psgSteps = [
      {
         number: 1,
         icon: psgIconClipboard,
         iconClass: classes.psgIconPurple,
         alt: "Choose a Pepper Cloud CRM package",
         text: "Choose your Pepper Cloud AI WhatsApp CRM package and get a quotation from us.",
      },
      {
         number: 2,
         icon: psgIcon2,
         iconClass: classes.psgIconTeal,
         alt: "Generate Package ID",
         text: "Generate Package ID by logging in via Corppass on the SMEs Go Digital Package Builder.",
      },
      {
         number: 3,
         icon: psgIconUpload,
         iconClass: classes.psgIconBlue,
         alt: "Business Grant Portal",
         text: "Submit your EDGE grant application on the Business Grant Portal (BGP) using your Package ID.",
         href: "https://www.businessgrants.gov.sg/",
      },
      {
         number: 4,
         icon: psgIcon1,
         iconClass: classes.psgIconOrange,
         alt: "Grant approval",
         text: "Await official grant approval before commencing your project.",
      },
   ];

   useEffect(() => {
      const cards = document.querySelectorAll(`.${classes.benefitCard}`);

      const gradients = [
         "rgba(0, 154, 153, 0.5)",
         "rgba(158, 90, 213, 0.5)",
         "rgba(32, 142, 236, 0.5)",
      ];

      cards.forEach((card, index) => {
         card.classList.add("glass-effect");
         card.style.setProperty("--before-gradient", gradients[index % 3]);

         const setInitialPosition = () => {
            const rect = card.getBoundingClientRect();
            card.style.setProperty("--before-left", `${rect.width - 150}px`);
            card.style.setProperty("--before-top", "0px");
            card.style.setProperty("--before-opacity", "0");
         };

         setInitialPosition();

         let lastX = null;
         let lastY = null;

         const handleMouseMove = (e) => {
            const rect = card.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            lastX = x;
            lastY = y;
            card.style.setProperty("--before-left", `${x - 150}px`);
            card.style.setProperty("--before-top", `${y - 150}px`);
         };

         const handleMouseEnter = () => {
            if (lastX !== null && lastY !== null) {
               card.style.setProperty("--before-left", `${lastX - 150}px`);
               card.style.setProperty("--before-top", `${lastY - 150}px`);
            }
            card.style.setProperty("--before-opacity", "1");
         };

         const handleMouseLeave = () => {
            card.style.setProperty("--before-opacity", "0");
         };

         card.handlers = {
            mousemove: handleMouseMove,
            mouseenter: handleMouseEnter,
            mouseleave: handleMouseLeave,
            resize: setInitialPosition,
         };

         card.addEventListener("mousemove", handleMouseMove);
         card.addEventListener("mouseenter", handleMouseEnter);
         card.addEventListener("mouseleave", handleMouseLeave);
         window.addEventListener("resize", setInitialPosition);
      });

      // Package section cards — initialX/Y match the CSS background-position of each card
      const packageCards = [
         // Monthly: "circle at 30% 80%" → bottom-left area
         {
            el: document.querySelector(`.${classes.packageTypeCardMonthly}`),
            color: "rgba(0, 154, 153, 0.6)",
            ix: 0.3,
            iy: 0.8,
         },
         // Enterprise: "circle at 20% 10%" → top-left area
         {
            el: document.querySelector(`.${classes.packageTypeCardEnterprise}`),
            color: "rgba(32, 142, 236, 0.6)",
            ix: 0.25,
            iy: 0.25,
         },
      ];

      packageCards.forEach(({ el: card, color, ix, iy }) => {
         if (!card) return;

         card.classList.add("glass-effect");
         card.style.setProperty("--before-gradient", color);

         // Place circle at the same spot as the card's existing CSS gradient
         const setInitialPosition = () => {
            const rect = card.getBoundingClientRect();
            card.style.setProperty(
               "--before-left",
               `${rect.width * ix - 150}px`,
            );
            card.style.setProperty(
               "--before-top",
               `${rect.height * iy - 150}px`,
            );
            card.style.setProperty("--before-opacity", "1");
         };

         setInitialPosition();

         let lastX = null;
         let lastY = null;

         const handleMouseMove = (e) => {
            const rect = card.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            lastX = x;
            lastY = y;
            card.style.setProperty("--before-left", `${x - 150}px`);
            card.style.setProperty("--before-top", `${y - 150}px`);
         };

         const handleMouseEnter = () => {
            if (lastX !== null && lastY !== null) {
               card.style.setProperty("--before-left", `${lastX - 150}px`);
               card.style.setProperty("--before-top", `${lastY - 150}px`);
            }
            card.style.setProperty("--before-opacity", "1");
         };

         // On leave: keep opacity and stay at last known position (don't reset)
         const handleMouseLeave = () => {
            card.style.setProperty("--before-opacity", "1");
         };

         card.handlers = {
            mousemove: handleMouseMove,
            mouseenter: handleMouseEnter,
            mouseleave: handleMouseLeave,
            resize: setInitialPosition,
         };

         card.addEventListener("mousemove", handleMouseMove);
         card.addEventListener("mouseenter", handleMouseEnter);
         card.addEventListener("mouseleave", handleMouseLeave);
         window.addEventListener("resize", setInitialPosition);
      });

      return () => {
         cards.forEach((card) => {
            const h = card.handlers;
            if (h) {
               card.removeEventListener("mousemove", h.mousemove);
               card.removeEventListener("mouseenter", h.mouseenter);
               card.removeEventListener("mouseleave", h.mouseleave);
               window.removeEventListener("resize", h.resize);
            }
         });
         packageCards.forEach(({ el: card }) => {
            if (!card) return;
            const h = card.handlers;
            if (h) {
               card.removeEventListener("mousemove", h.mousemove);
               card.removeEventListener("mouseenter", h.mouseenter);
               card.removeEventListener("mouseleave", h.mouseleave);
               window.removeEventListener("resize", h.resize);
            }
         });
      };
   }, [classes]);

   return (
      <div>
         <SEO
            canonical="/edge-grant/"
            jsonLd={faqSchema}
            description="Apply for the EDGE Grant by Singapore government and get up to 50% support grant for SMEs on eligible CRM projects."
            keywords="EDGE Grant Singapore,EDGE Grant for SMEs,EDGE Grant eligibility,EDGE Grant funding,EDGE Grant application,EDGE Grant approved solutions,EDGE Grant CRM software,EDGE Grant pre-approved vendors,EDGE Grant funding for CRM,Singapore business grant,EDGE Grant requirements,EDGE Grant application process,EDGE Grant support for SMEs"
            pathname="/edge-grant/"
            title="EDGE Grant for SMEs | Up to 50% Govt Funding - Pepper Cloud"
         />
         <Box
            alignItems="center"
            className={classes.securityBannerBg}
            component={Grid}
            container
            justify="center"
            pb={10}
            pt={{ xs: 0, sm: 4, md: 8 }}
         >
            <div className="container">
               <Grid
                  className={classes.heroSection}
                  container
                  spacing={4}
                  alignItems="flex-start"
               >
                  {/* Left: text content */}
                  <Grid item md={6} sm={12}>
                     <motion.div
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5 }}
                        viewport={{ once: false }}
                     >
                        <HeaderTypography
                           className={clsx(
                              classes.headerTextColor,
                              classes.bannerHeading,
                           )}
                           overrideClassName
                           component="h1"
                           fontWeight={600}
                           lineHeight={1.2}
                           mb={3}
                           mt={0}
                           textAlign={"left"}
                        >
                           Automate growth with{" "}
                           <span
                              style={{
                                 background:
                                    "linear-gradient(90deg, #268BEB, #9E5AD5)",
                                 WebkitBackgroundClip: "text",
                                 WebkitTextFillColor: "transparent",
                                 backgroundClip: "text",
                              }}
                           >
                              up to 50% EDGE grant{" "}
                           </span>
                           support
                        </HeaderTypography>
                     </motion.div>

                     <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.15 }}
                        viewport={{ once: false }}
                     >
                        <ParagraphTypography
                           className={clsx(
                              classes.smeFooterText,
                              classes.bannerText,
                           )}
                           color="#0A2035"
                           lineHeight={1.6}
                           mb={3}
                           mt={4}
                        >
                           Access up to 50% grant support for eligible
                           activities under Singapore's new business grant and
                           adopt Pepper Cloud AI WhatsApp CRM to streamline
                           sales, customer engagement, and support operations.
                        </ParagraphTypography>
                     </motion.div>

                     <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.25 }}
                        viewport={{ once: false }}
                     >
                        <Box
                           display="flex"
                           flexDirection="column"
                           style={{ gap: "12px" }}
                        >
                           {[
                              "Simple and easy to use",
                              "Quick implementation",
                              "24/7 Local support",
                           ].map((each) => (
                              <ParagraphTypography
                                 className={classes.bannerText}
                                 color="#0A2035"
                                 component="div"
                                 display="flex"
                                 alignItems="center"
                                 fontFamily="inter !important"
                                 fontWeight={400}
                                 key={each}
                                 lineHeight={1.6}
                                 m={0}
                              >
                                 <Box
                                    alt={each}
                                    component="img"
                                    height={24}
                                    mr={1.5}
                                    src={tick}
                                    width={24}
                                    flexShrink={0}
                                 />
                                 {each}
                              </ParagraphTypography>
                           ))}
                        </Box>
                     </motion.div>
                  </Grid>

                  {/* Right: form card */}
                  <Box
                     component={Grid}
                     id="psg-form-container"
                     item
                     md={6}
                     p={0}
                     sm={12}
                     width={{ sm: "100%", xs: "100%" }[width]}
                     display="flex"
                     justifyContent={
                        { sm: "center", xs: "center" }[width] || "flex-end"
                     }
                  >
                     <motion.div
                        initial={{ opacity: 0, x: 30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5, delay: 0.3 }}
                        viewport={{ once: false }}
                        style={{ width: "100%", maxWidth: 460 }}
                     >
                        <Box className={classes.formCard} id="psg-form">
                           <Box className={classes.formCardHeader}>
                              <HeaderTypography
                                 color="white"
                                 component="h5"
                                 fontSize={22}
                                 fontWeight={700}
                                 m={0}
                              >
                                 Avail up to <span>50%</span> business grant
                              </HeaderTypography>
                           </Box>
                           <Box className={classes.formCardBody}>
                              <LazyLoad offset={100} once>
                                 <Box height={655}>
                                    <Box
                                       border="none"
                                       component="iframe"
                                       height="100%"
                                       overflow="hidden"
                                       src="https://app.peppercloud.com/form/a812ffea-9ed4-4946-b5e0-67052acf3e97/embed"
                                       title="Contact Us"
                                       width="100%"
                                    />
                                 </Box>
                              </LazyLoad>
                           </Box>
                        </Box>
                     </motion.div>
                  </Box>
               </Grid>
               <Box mt={4} mb={2} px={2}>
                  <Box
                     alt="Pepper Cloud CRM - AI insights, opportunity tracking and customer support"
                     component="img"
                     src={mainHeaderImg}
                     width="100%"
                     height="auto"
                  />
               </Box>
            </div>
         </Box>

         {/* Benefits Card Grid */}
         <Box className={classes.benefitsSection}>
            <div className="container">
               <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  viewport={{ once: false }}
               >
                  <Box className={classes.benefitsSectionTitle}>
                     Pepper Cloud is an AI-powered WhatsApp CRM for Singapore businesses
                  </Box>
               </motion.div>

               {/* Row 1: 35% | 65% */}
               <Grid container spacing={2} className={classes.benefitsRow}>
                  <Grid
                     item
                     xs={12}
                     md={4}
                     className={classes.benefitsGridItem}
                  >
                     <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.1 }}
                        viewport={{ once: false }}
                        style={{ width: "100%", display: "flex" }}
                     >
                        <Box className={classes.benefitCard}>
                           <Box className={classes.benefitCardTitle}>
                              AI-powered CRM
                           </Box>
                           <Box className={classes.benefitCardDesc}>
                              Bring sales, customer conversations, and support
                              workflows together with AI WhatsApp CRM to manage
                              customer interactions and streamline sales and
                              support from one platform.
                           </Box>
                           <Box
                              alt="All-in-one sales CRM integrations"
                              component="img"
                              src={psgCard4}
                              className={classes.benefitCardImg}
                           />
                        </Box>
                     </motion.div>
                  </Grid>
                  <Grid
                     item
                     xs={12}
                     md={8}
                     className={classes.benefitsGridItem}
                  >
                     <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                        viewport={{ once: false }}
                        style={{ width: "100%", display: "flex" }}
                     >
                        <Box className={classes.benefitCard}>
                           <Box className={classes.benefitCardTitle}>
                              Simple and easy to use
                           </Box>
                           <Box className={classes.benefitCardDesc}>
                              Pepper Cloud AI CRM makes it easier to digitalise
                              sales operations, organise customer information
                              and manage follow-ups, helping your team spend
                              less time on manual processes and more time
                              engaging customers.
                           </Box>
                           <Box
                              alt="Simple and easy-to-use leads view"
                              component="img"
                              src={psgCard6}
                              className={classes.benefitCardImg}
                           />
                        </Box>
                     </motion.div>
                  </Grid>
               </Grid>

               {/* Row 2: 28% | 28% | 44% */}
               <Grid container spacing={2} className={classes.benefitsRow}>
                  <Grid item xs={12} className={classes.benefitsCol28}>
                     <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.1 }}
                        viewport={{ once: false }}
                        style={{ width: "100%", display: "flex" }}
                     >
                        <Box className={classes.benefitCard}>
                           <Box className={classes.benefitCardTitle}>
                              Local support and guidance
                           </Box>
                           <Box className={classes.benefitCardDesc}>
                              Get ongoing support and guidance from the Pepper
                              Cloud team throughout your CRM adoption.
                           </Box>
                           <Box
                              alt="Local support chat"
                              component="img"
                              src={psgCard3}
                              className={classes.benefitCardImg}
                           />
                        </Box>
                     </motion.div>
                  </Grid>
                  <Grid item xs={12} className={classes.benefitsCol28}>
                     <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                        viewport={{ once: false }}
                        style={{ width: "100%", display: "flex" }}
                     >
                        <Box className={classes.benefitCard}>
                           <Box className={classes.benefitCardTitle}>
                              Full implementation and training
                           </Box>
                           <Box className={classes.benefitCardDesc}>
                              Get implementation assistance and training to help
                              your team adopt Pepper Cloud AI WhatsApp CRM
                              efficiently.
                           </Box>
                           <Box
                              alt="Full implementation and training"
                              component="img"
                              src={psgCard1}
                              className={classes.benefitCardImg}
                           />
                        </Box>
                     </motion.div>
                  </Grid>
                  <Grid item xs={12} className={classes.benefitsColRemaining}>
                     <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.3 }}
                        viewport={{ once: false }}
                        style={{ width: "100%", display: "flex" }}
                     >
                        <Box className={classes.benefitCard}>
                           <Box className={classes.benefitCardTitle}>
                              Flexible pricing options
                           </Box>
                           <Box className={classes.benefitCardDesc}>
                              Choose a Pepper Cloud AI CRM package based on your
                              users, business requirements, and desired
                              capabilities. For customised requirements, our
                              team can help you identify the right
                              configuration.
                           </Box>
                           <Box
                              alt="Flexible pricing options"
                              component="img"
                              src={psgCard7}
                              className={classes.benefitCardImg}
                           />
                        </Box>
                     </motion.div>
                  </Grid>
               </Grid>

               {/* Row 3: 65% | 35% */}
               <Grid container spacing={2}>
                  <Grid
                     item
                     xs={12}
                     md={8}
                     className={classes.benefitsGridItem}
                  >
                     <motion.div
                        initial={{ opacity: 0, x: -40 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5, delay: 0.1 }}
                        viewport={{ once: false }}
                        style={{ width: "100%", display: "flex" }}
                     >
                        <Box
                           className={clsx(
                              classes.benefitCard,
                              classes.benefitCardRow,
                           )}
                        >
                           <Box className={classes.benefitCardRowText}>
                              <Box
                                 className={clsx(
                                    classes.benefitCardTitle,
                                    classes.benefitCardTitleRow,
                                 )}
                              >
                                 Automatic version upgrades
                              </Box>
                              <Box
                                 className={clsx(
                                    classes.benefitCardDesc,
                                    classes.benefitCardDescRow,
                                 )}
                              >
                                 Stay up to date with the latest WhatsApp + AI
                                 features and improvements through automatic
                                 platform upgrades, without the need for manual
                                 system updates.
                              </Box>
                           </Box>
                           <Box
                              alt="Automatic version upgrades dashboard"
                              component="img"
                              src={psgCard5}
                              className={classes.benefitCardRowImg}
                           />
                        </Box>
                     </motion.div>
                  </Grid>
                  <Grid
                     item
                     xs={12}
                     md={4}
                     className={classes.benefitsGridItem}
                  >
                     <motion.div
                        initial={{ opacity: 0, x: 40 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                        viewport={{ once: false }}
                        style={{ width: "100%", display: "flex" }}
                     >
                        <Box className={classes.benefitCard}>
                           <Box className={classes.benefitCardTitle}>
                              No hidden costs
                           </Box>
                           <Box className={classes.benefitCardDesc}>
                              Get transparent pricing with a clear view of your
                              CRM subscription and implementation requirements,
                              so you can plan your investment with confidence.
                           </Box>
                           <Box
                              alt="No hidden costs badge"
                              component="img"
                              src={psgCard2}
                              className={classes.benefitCardImg}
                           />
                        </Box>
                     </motion.div>
                  </Grid>
               </Grid>
            </div>
         </Box>
         <Divider />
         <Box className={classes.psgApplicationProcess}>
            <Box className="container">
               <div className={classes.commonSpacing}>
                  <motion.div
                     initial={{ opacity: 0, y: 30 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     transition={{ duration: 0.5 }}
                     viewport={{ once: false }}
                     className="container"
                  >
                     <HeaderTypography
                        className={clsx(
                           classes.headerTextColor,
                           classes.mainHeading,
                        )}
                        component="h2"
                        lineHeight={1.2}
                        mt="0"
                        textAlign="center"
                     >
                        How to apply for EDGE grant support in Singapore? 
                     </HeaderTypography>
                  </motion.div>

                  {/* Application steps */}
                  <Box className={classes.psgSteps}>
                     {psgSteps.map((step, index) => (
                        <motion.div
                           key={step.number}
                           className={classes.psgStep}
                           initial={{ opacity: 0, y: 30 }}
                           whileInView={{ opacity: 1, y: 0 }}
                           transition={{
                              duration: 0.5,
                              delay: 0.1 + index * 0.1,
                           }}
                           viewport={{ once: false }}
                        >
                           <Box className={classes.psgStepDotWrap}>
                              <Box className={classes.psgStepDot}>
                                 {step.number}
                              </Box>
                           </Box>
                           <Box className={classes.psgStepCardWrap}>
                              <Paper
                                 className={clsx(
                                    classes.psgBox,
                                    step.href && classes.psgBoxLink,
                                 )}
                                 component={step.href ? "a" : "div"}
                                 elevation={0}
                                 {...(step.href
                                    ? {
                                         href: step.href,
                                         rel: "nofollow",
                                         target: "_blank",
                                         onClick: step.onClick,
                                      }
                                    : {})}
                              >
                                 <Box
                                    className={clsx(
                                       classes.psgIconContainer,
                                       step.iconClass,
                                    )}
                                 >
                                    <Box
                                       alt={step.alt}
                                       component="img"
                                       height={24}
                                       src={step.icon}
                                       width={24}
                                    />
                                 </Box>
                                 <p className={classes.psgCardText}>
                                    {step.text}
                                 </p>
                              </Paper>
                           </Box>
                        </motion.div>
                     ))}
                  </Box>

                  {/* IMDA Lockup */}
                  <motion.div
                     initial={{ opacity: 0, y: 20 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     transition={{ duration: 0.5, delay: 0.2 }}
                     viewport={{ once: false }}
                  >
                     <IMDALockup />
                  </motion.div>

                  {/* Apply Now */}
                  <motion.div
                     initial={{ opacity: 0, y: 20 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     transition={{ duration: 0.5, delay: 0.3 }}
                     viewport={{ once: false }}
                  >
                     <Box display="flex" justifyContent="center" mt={4}>
                        <button
                           className={clsx(
                              classes.ButtonRound32,
                              "primaryButton font-20 colorWhite",
                           )}
                           onClick={glowForm}
                        >
                           Apply now
                        </button>
                     </Box>
                  </motion.div>
               </div>
            </Box>
         </Box>

         <Divider />
         <Box className={classes.packageSection} id="packages">
            <div className="container">
               <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  viewport={{ once: false }}
               >
                  <Box className={classes.packageSectionTitle}>
                     Pepper Cloud AI WhatsApp CRM packages for Singapore
                     businesses
                  </Box>
               </motion.div>

               <Box className={classes.packagesRow}>
                  {/* Monthly Subscription */}
                  <Box className={classes.packageTypeCardMonthly}>
                     <Box className={classes.packageTypeTitle}>
                        Monthly subscription
                     </Box>
                     <Box className={classes.packageItemsRow}>
                        {[
                           { users: "03", label: "Users" },
                           { users: "05", label: "Users" },
                           { users: "10", label: "Users" },
                        ].map((pkg) => (
                           <Box
                              key={pkg.users}
                              className={classes.packageItemEnterprise}
                           >
                              <Box className={classes.packageUserCount}>
                                 {pkg.users}
                              </Box>
                              <Box className={classes.packageUserLabel}>
                                 {pkg.label}
                              </Box>
                           </Box>
                        ))}
                     </Box>
                     <button className={classes.packageBtn} onClick={glowForm}>
                        Choose your package
                     </button>
                  </Box>

                  {/* Enterprise License */}
                  <Box className={classes.packageTypeCardEnterprise}>
                     <Box className={classes.packageTypeTitle}>
                        Enterprise License
                     </Box>
                     <Box className={classes.packageItemEnterprise}>
                        <Box className={classes.packageUserCount}>30</Box>
                        <Box className={classes.packageUserLabel}>Users</Box>
                     </Box>
                     <button className={classes.packageBtn} onClick={glowForm}>
                        Choose your package
                     </button>
                  </Box>
               </Box>

               <Box className={classes.packageFootnote}>
                  *For customised CRM requirements or solutions that fall
                  outside the standard packages, please email us at{" "}
                  <a href="mailto:sales@peppercloud.com">
                     sales@peppercloud.com
                  </a>
               </Box>
            </div>
         </Box>
         <Divider />
         <FaqSection
            backgroundColor="#ffffff"
            noMobilePadding={true}
            heading="EDGE grant - Frequently asked questions"
            faqs={faqs}
         />

         <Box className={clsx(classes.requestDemoRoot, classes.commonSpacing)}>
            <Container>
               <HeaderTypography
                  className={clsx(
                     classes.requestDemoRootWidth,
                     classes.mainHeading,
                  )}
                  color="common.white"
                  component="h2"
                  lineHeight={1.2}
                  mt={0}
                  textAlign="center"
               >
                 Upgrade your AI CRM with business grant support
               </HeaderTypography>
               <Box display="flex" justifyContent="center" mt={2}>
                  <button
                     className={clsx(
                        classes.ButtonRound32,
                        "primaryButton font-20 colorWhite",
                     )}
                     onClick={glowForm}
                  >
                     {/* eslint-disable-next-line react/no-unescaped-entities */}
                     Book a free demo
                  </button>
               </Box>
            </Container>
         </Box>
      </div>
   );
};

export default PSG;
